import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Topic {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  tag_color: string | null;
  icon_svg: string | null;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

async function fetchTopics(): Promise<Topic[]> {
  const { data, error } = await supabase
    .from('topics')
    .select('*')
    .order('display_order', { ascending: true });

  if (error) throw error;

  return (data || []).map((item: any) => ({
    id: item.id,
    name: item.name,
    slug: item.slug,
    description: item.description,
    tag_color: item.tag_color,
    icon_svg: item.icon_svg,
    display_order: item.display_order,
    is_active: item.is_active,
    created_at: item.created_at,
    updated_at: item.updated_at,
  }));
}

export function useTopics() {
  return useQuery({
    queryKey: ['topics'],
    queryFn: fetchTopics,
    staleTime: 30000,
    refetchOnWindowFocus: false,
  });
}
